import { createLazyResolver, createLazySubscriptionResolver } from 'owa-lazy-resolver';

// TODO: Naming and directory structure - to be finalized.
export const lazyFolderHierarchyWeb = createLazyResolver(
    'QUERY_PRIMARY_FOLDER_HIERARCHY_WEB',
    () => import('./queries/folderHierarchyWeb'),
    m => m.folderHierarchyWeb
);

export const lazyRenameFolderWeb = createLazyResolver(
    'MUTATION_RENAME_FOLDER_WEB',
    () => import('./queries/renameFolderWeb'),
    m => m.renameFolderWeb
);

export const lazyEmptyFolderWeb = createLazyResolver(
    'MUTATION_EMPTY_FOLDER_WEB',
    () => import('./queries/emptyFolderWeb'),
    m => m.emptyFolderWeb
);

export const lazyDeleteFolderWeb = createLazyResolver(
    'MUTATION_DELETE_FOLDER_WEB',
    () => import('./queries/deleteFolderWeb'),
    m => m.deleteFolderWeb
);

export const lazySubscribeToHierarchyNotificationsWeb = createLazySubscriptionResolver(
    () => import('./queries/subscribeToHierarchyNotificationsWeb'),
    m => m.subscribeToHierarchyNotificationsWeb
);
